import React from 'react';
import { IonText, IonBadge } from '@ionic/react';

interface EditorSelectionSectionProps {
  title: string;
  badgeText?: string;
  children: React.ReactNode;
}

const EditorSelectionSection: React.FC<EditorSelectionSectionProps> = ({
  title,
  badgeText,
  children
}) => {
  return (
    <div style={{ marginBottom: '1.25rem' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '0.5rem',
        padding: '0.25rem 0.5rem'
      }}>
        <IonText color="primary">
          <h2 style={{ margin: 0, fontSize: '0.95rem', letterSpacing: '0.02em' }}>{title}</h2>
        </IonText>
        {badgeText && <IonBadge color="medium">{badgeText}</IonBadge>}
      </div>
      <div style={{ border: '1px solid var(--ion-color-light)', borderRadius: '0.6rem', padding: '0.25rem 0.35rem' }}>
        {children}
      </div>
    </div>
  );
};

export default EditorSelectionSection;
